var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"location"},[_c('p',{staticClass:"overflow-ellipsis",on:{"mouseleave":_vm.closeTooltip,"mouseover":function($event){return _vm.openTooltip(_vm.location, $event)}}},[_vm._v(_vm._s(_vm.location))])])}
var staticRenderFns = []

export { render, staticRenderFns }